if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.countdownInterval = null;
    }

    connectedCallback() {
      this.initCountdown();
    }

    disconnectedCallback() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
    }

    initCountdown() {
      const targetDate = new Date(`${this.dataset.targetDate}T${this.dataset.targetTime}:00`).getTime();

      const timerElement = this.querySelector('.countdown-timer');
      const expiredElement = this.querySelector('.countdown-expired');
      const daysElement = this.querySelector('.countdown-days');
      const hoursElement = this.querySelector('.countdown-hours');
      const minutesElement = this.querySelector('.countdown-minutes');
      const secondsElement = this.querySelector('.countdown-seconds');

      if (!timerElement || !targetDate) {
        console.error('Countdown timer: Missing required elements or target date');
        return;
      }

      const updateCountdown = () => {
        const now = new Date().getTime();
        const distance = targetDate - now;

        if (distance < 0) {
          clearInterval(this.countdownInterval);
          const countdownContainer = this.closest('.header-countdown, .countdown-section');
          if (countdownContainer) {
            countdownContainer.remove();
            return;
          }

          this.remove();
          return;
        }

        // Calculate time units
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Update display with zero padding
        if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
        if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
        if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
        if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
      };

      updateCountdown();

      this.countdownInterval = setInterval(updateCountdown, 1000);
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}